
export default {
    data() {
        return {
            confirm: 0,
        }
    },
}
